import {
  urlCheckerList,
  urlCheckerStats,
  urlCheckerCheckAll,
  urlCheckerToggle,
  urlCheckerOverride,
  urlCheckerRecheck,
  urlCheckerGetSettings,
  urlCheckerUpdateSettings,
} from '@/services/jobs/urlChecker.service'

export default {
  namespaced: true,
  state: {
    list: { data: [], meta: { pagination: { total: 0 } } },
    stats: { total: 0, active: 0, inactive: 0, error: 0, needs_review: 0, unchecked: 0, disabled: 0 },
    settings: { auto_deactivate_enabled: false, deactivate_in_system: false },
    status: 'init',
    actionStatus: 'init',
  },
  getters: {
    getList:        s => s.list,
    getStats:       s => s.stats,
    getSettings:    s => s.settings,
    getStatus:      s => s.status,
    getActionStatus:s => s.actionStatus,
  },
  mutations: {
    SET_LIST(state, payload)     { state.list = payload },
    SET_STATS(state, payload)    { state.stats = payload },
    SET_SETTINGS(state, payload) { state.settings = payload },
    SET_STATUS(state, v)         { state.status = v },
    SET_ACTION(state, v)         { state.actionStatus = v },
    UPDATE_ROW(state, { vacancyId, patch }) {
      const row = state.list.data.find(r => r.vacancy_id === vacancyId)
      if (row) Object.assign(row, patch)
    },
  },
  actions: {
    async fetchList({ commit }, params) {
      commit('SET_STATUS', 'loading')
      try {
        const { data } = await urlCheckerList(params)
        // Backend returns Laravel paginator: { data: [], total, current_page, ... }
        // Normalize to Fractal shape the view expects: { data: [], meta: { pagination: { total } } }
        commit('SET_LIST', {
          data: data.data || [],
          meta: { pagination: { total: data.total || 0 } },
        })
        commit('SET_STATUS', 'done')
      } catch {
        commit('SET_STATUS', 'error')
      }
    },
    async fetchStats({ commit }) {
      try {
        const { data } = await urlCheckerStats()
        commit('SET_STATS', data)
      } catch { /* silent */ }
    },
    async checkAll({ commit }) {
      commit('SET_ACTION', 'loading')
      try {
        await urlCheckerCheckAll()
        commit('SET_ACTION', 'done')
      } catch {
        commit('SET_ACTION', 'error')
      }
    },
    async toggle({ commit }, vacancyId) {
      commit('SET_ACTION', 'loading')
      try {
        const { data } = await urlCheckerToggle(vacancyId)
        commit('UPDATE_ROW', { vacancyId, patch: { check_enabled: data.check_enabled } })
        commit('SET_ACTION', 'done')
      } catch {
        commit('SET_ACTION', 'error')
      }
    },
    async override({ commit }, vacancyId) {
      commit('SET_ACTION', 'loading')
      try {
        await urlCheckerOverride(vacancyId)
        commit('UPDATE_ROW', { vacancyId, patch: { url_check_status: 'active', manually_overridden: true } })
        commit('SET_ACTION', 'done')
      } catch {
        commit('SET_ACTION', 'error')
      }
    },
    async fetchSettings({ commit }) {
      try {
        const { data } = await urlCheckerGetSettings()
        commit('SET_SETTINGS', data)
      } catch { /* silent */ }
    },
    async updateSettings({ commit }, payload) {
      const { data } = await urlCheckerUpdateSettings(payload)
      commit('SET_SETTINGS', data)
    },
    async recheck({ commit }, vacancyId) {
      commit('SET_ACTION', 'loading')
      try {
        const { data } = await urlCheckerRecheck(vacancyId)
        commit('UPDATE_ROW', { vacancyId, patch: {
          url_check_status:           data.status,
          url_check_http_status:      data.http_status,
          url_check_reason:           data.reason,
          url_check_confidence_score: data.confidence,
          url_checked_at:             data.checked_at,
          manually_overridden:        false,
        }})
        commit('SET_ACTION', 'done')
        return data
      } catch {
        commit('SET_ACTION', 'error')
      }
    },
  },
}
